import {
  type GetTutorialsResponse,
  getTutorials,
  type Tutorial,
} from '@otter-ai/recall-client';
import { HOUR_MS } from '@/constants/time';
import type { AdditionalQueryOptions } from '@/shared/utils/queryCreators';

type tutorialsQueryKey = ['tutorials'];

type TutorialsAdditionalQueryOptions = AdditionalQueryOptions<
  GetTutorialsResponse,
  tutorialsQueryKey
>;

export type TutorialsQuery = {
  readonly queryKey: tutorialsQueryKey;
  readonly queryFn: () => Promise<GetTutorialsResponse>;
} & TutorialsAdditionalQueryOptions;

export function tutorialsQueryCreator(
  additionalOptions: TutorialsAdditionalQueryOptions = {},
): TutorialsQuery {
  return {
    staleTime: 2 * HOUR_MS,
    queryKey: ['tutorials'],
    queryFn: async () => {
      const response = await getTutorials({
        query: { appid: 'otter-web' },
        throwOnError: true,
      });
      return response.data;
    },
    ...additionalOptions,
  };
}

/**
 * Get a specific tutorial by name from the tutorials list
 */
export function getTutorialByName(
  tutorials: Tutorial[] | undefined,
  name: string,
): Tutorial | undefined {
  return tutorials?.find((t) => t.name === name);
}
